import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import { LendingEquipmentCertificationsDonutChart } from '../../../statistics/lending/lending-equipment-certifications-donut-chart/lending-equipment-certifications-donut-chart.component';
import { LendingEquipmentStateDonutChart } from '../../../statistics/lending/lending-equipment-state-donut-chart/lending-equipment-state-donut-chart.component';
import { LendingLongestInUseEquipmentsListCard } from '../../../statistics/lending/lending-longest-in-use-equipments-list-card/lending-longest-in-use-equipments-list-card.component';
import { LendingUnavailableProductsListCard } from '../../../statistics/lending/lending-unavailable-products-list-card/lending-unavailable-products-list-card.component';
import { Dashboard, DashboardCard } from '../../../statistics/shared';
import OverviewHeader from '../../header/overview-header';

const LendingDashboard = () => {
    const { currentAccount } = useAccountRepository();

    return (
        <div
            key='lending-dashboard'
            className='bg-background-default flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='lending-dashboard.title'
                        description='Page title of the Lending application dashboard'
                        defaultMessage='Lending / Dashboard'
                    />
                }
            />
            <Dashboard>
                <DashboardCard size='2x2'>
                    <LendingEquipmentStateDonutChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x2'>
                    <LendingEquipmentCertificationsDonutChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='3x2'>
                    <LendingLongestInUseEquipmentsListCard accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x2'>
                    <LendingUnavailableProductsListCard accountId={currentAccount} />
                </DashboardCard>
            </Dashboard>
        </div>
    );
};

export default LendingDashboard;
